import { useUsers } from '../../../../metodos/userContext';
import BooleanField from '../../../../components/BooleanField';
import EditableField from '../../../../components/EditableFields';
import { useTutoresModel } from '../../../../modelos/Tutores/modeloTutores';
import React, { useEffect , useState } from 'react'
import { useParams } from 'react-router-dom';
import { useNombreEmpresaReal } from '../../../../config/unificacion';
import SelectorMaterias from '../../../../views/Utils/selectorMaterias';
import { useListasModel } from '../../../../modelos/listas/modeloListas';
import { BotonVolver } from '../../../../utils/navigator';
import { Pencil, Trash2 } from 'lucide-react';
import { EditableWidget } from '../../../../components/EditableWidget';
import ListaMaterias from '../../../../views/Utils/listaMaterias';
import CuentasBancariasForm from '../../../../views/Utils/selectorCuentaBancaria';
import ListaCuentasBancarias from '../../../../views/Utils/listaCuentasBancarias';
import SelectorTipoServicios from '../../../../views/Utils/selectorTipoServicios';
import ListaTiposServicios from '../../../../views/Utils/listaTiposServicios';
import { TutorStats } from '../../../../views/compartedRoutes/solicitudes/Modulos/Cotizaciones';
import ExperienciaLaboralForm from '../../../../views/Utils/selectorExperienciaLaboral';
import ListaExperienciaLaboral from '../../../../views/Utils/listaExperienciaLaboral';

const DetallesTutor = () => {
  const { nombreEmpresa, uidTutor } = useParams();
  const {
    tutor,
    updateTutor,
    loaadingTutor,
    cargarTutorPorUid,
    setupWebSocketTutores,
    obtenerEstadisticasTutor,
  } = useTutoresModel();
  const [materiaSeleccioandas, setMateriasSeleccionadas] = useState(tutor?.materias || []);
  const {
    materias,
    cargarMaterias,
    paises,
    cargarPaises,
    ciudades,
    cargarCiudades,
    carrerasOptions,
    cargarCarreras,
    universidadesOptions,
    cargarUniversidades,
  } = useListasModel();

  //pais, ciudad, carrera, universidad
  const [formData, setFormData] = useState({
    cuentas: [],
    tipoServicios: [],
    experienciaLaboral: [],
  });

  const nombreEmpresaReal = useNombreEmpresaReal(nombreEmpresa);
  const { usuario } = useUsers();

  //estadisticas de tutores
  const [estadisticasTutores, setEstadisticasTutores] = useState({});
  const [loadingEstadisticas, setLoadingEstadisticas] = useState(false);
  //cargar estadisticas
  
  useEffect(() => {
    if (!tutor || !tutor.nombrewhatsapp) return;

    const cargarEstadisticas = async () => {
      try {
        setLoadingEstadisticas(true);
        // Hacemos la petición
        const data = await obtenerEstadisticasTutor(tutor.nombrewhatsapp);
              
        setEstadisticasTutores(data); 

      } catch (error) {
        console.error("Error cargando estadísticas:", error);
      } finally {
            setLoadingEstadisticas(false); // Terminamos carga (haya éxito o error)
        }
    };

    cargarEstadisticas();

  }, [tutor]);
  
  
  useEffect(() =>{
    let socketCleanup = null;

    const cargarTutor = async() =>{
      const tutorObjeto = await cargarTutorPorUid(uidTutor);


      if(tutorObjeto){
        socketCleanup = setupWebSocketTutores(tutorObjeto,nombreEmpresaReal);
      }

    }

    cargarTutor();
    cargarMaterias();
    //cargar demas
    cargarPaises();
    cargarCiudades();
    cargarCarreras();
    cargarUniversidades();
    
  },[]);

  //cargar materias seleccionadas
  useEffect(() => {

    if (tutor?.materias) {
      setMateriasSeleccionadas(tutor.materias);
    }
    
  }, [tutor]);

  if(loaadingTutor){
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600">Cargando detalles de el tutor...</p>
      </div>
    );
  }

  // Validar que el tutor existe antes de renderizar
  if (!tutor) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center">
        <p className="text-gray-600">No se encontró información del tutor</p>
      </div>
    );
  }

  const updateTutorLocalAuxiliar = (field,value,typefield = "field") =>{
    console.log("update tutor auxiliar",field,value);
    updateTutor(uidTutor,nombreEmpresa,field,value,typefield);
  }

  const vistaTutor = () =>{ 
    return(
      <div className="min-h-screen bg-gray-100 py-8">
        <div className="max-w-6xl mx-auto px-4">
          {/* Header */}
          <div className="mb-8 flex items-center">

            <BotonVolver
              ruta='/tutores'
            />

          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Información Personal */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-lg p-6">

                {/* Foto de perfil */}
                <div className="text-center mb-6">
                  {/* El contenedor 'relative' es clave para posicionar los iconos */}
                  <div className="relative inline-block">
                    <img 
                      src={tutor?.fotoPerfil || '/api/placeholder/150/150'} 
                      alt="Foto de perfil" 
                      className="w-32 h-32 rounded-full mx-auto border-4 border-blue-500 object-cover"
                    />

                    Aun no sirven botones
                    {/* --- Botón de Editar Foto --- */}
                    <button
                      type="button"
                      onClick={() => { /* Lógica para editar/subir foto */ }}
                      className="absolute bottom-1 right-1 flex h-9 w-9 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      aria-label="Editar foto de perfil"
                      title="Editar foto"
                    >
                      {/* Icono de Lucide */}
                      <Pencil className="h-5 w-5" />
                    </button>

                    {/* --- Botón de Eliminar Foto (Moderación) --- */}
                    <button
                      type="button"
                      onClick={() => { /* Lógica para confirmar y eliminar la foto */ }}
                      className="absolute top-1 right-1 flex h-9 w-9 items-center justify-center rounded-full bg-red-600 text-white shadow-lg transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                      aria-label="Eliminar foto de perfil"
                      title="Eliminar foto"
                    >
                      {/* Icono de Lucide */}
                      <Trash2 className="h-5 w-5" />
                    </button>
                  </div>
                </div>

                <h2 className="text-xl font-semibold text-blue-600 mb-4">Información personal</h2>
                
                <div className="space-y-4">
                
                  <EditableField
                      label="Nombre Whatsapp ❌"
                      value={tutor.nombrewhatsapp}
                      type="field"
                    />

                  <EditableField
                      field="nombre completo"
                      label="Nombre Completo"
                      value={tutor.nombreCompleto}
                      type="field"
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                  <EditableField
                      field="numero whatsapp"
                      label="Número de Whatsapp"
                      value={tutor.numeroWhatsapp}
                      type="field"
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                    <EditableField
                      field="paisOrigen"
                      label="País"
                      value={tutor.paisOrigen}
                      type="react-select"
                      options={paises}
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                    <EditableField
                      field="identificacionTutor"
                      label="Cédula"
                      value={tutor.identificacionTutor}
                      type="field"
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                    <EditableField
                      field="ciudadOrigen"
                      label="Ciudad"
                      value={tutor.ciudadOrigen}
                      type="react-select"
                      options={ciudades}
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                    <EditableField
                      field="carrera"
                      label="Carrera"
                      value={tutor.carrera}
                      type="react-select"
                      options={carrerasOptions}
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                    <EditableField
                      field="Correo gmail"
                      label="Correo gmail"
                      value={tutor.correogmail}
                      type="field"
                    />

                    <EditableField
                      field="Universidad"
                      label="Universidad"
                      value={tutor.universidad}
                      type="react-select"
                      options={universidadesOptions}
                      isAdmin={true}
                      onSave={updateTutorLocalAuxiliar}
                    />

                </div>

                {/* Configuraciones */}
                <div className="mt-6 pt-6 border-t">
                  <div className="space-y-3">
                    
                    {/* Tutor Inactivo - Quitar notificaciones */}
                    <BooleanField
                      field="activo"
                      label="Tutor Activo"
                      value={tutor.activo}
                      isAdmin={true}
                      displayAs='toggle'
                      onSave={updateTutorLocalAuxiliar}
                    />

                    {/* Tutor Expulsado */}
                    <BooleanField
                      field="expulsado"
                      label="Tutor Expulsado"
                      value={tutor.expulsado}
                      isAdmin={true}
                      displayAs='toggle'
                      onSave={updateTutorLocalAuxiliar}
                    />

                    configuracion aun no programadas ni enlazadas

                    {/* Aparecer mas solicitudes por Materia IA */}
                    <BooleanField
                      field="Materia IA"
                      label="Tutor Expulsado"
                      value={tutor.expulsado}
                      isAdmin={false}
                      displayAs='toggle'
                      //onSave={updateTutorLocalAuxiliar}
                    />

                    {/* Aparecer mas solicitudes por Carrera IA */}
                    <BooleanField
                      field="carrera IA"
                      label="Tutor Expulsado"
                      value={tutor.expulsado}
                      isAdmin={false}
                      displayAs='toggle'
                      //onSave={updateTutorLocalAuxiliar}
                    />

                  </div>

                  {/* Info completa de usuario */}
                  <div className="mt-4 text-center">
                    <span className="text-sm text-green-600 font-medium">
                      {tutor?.infoCompletaUsuario ? 'Toda la información está completa.' : 'Información incompleta'}
                    </span>
                  </div>

                </div>
              </div>

              {/* Cuentas Bancarias - widget programado */}
              <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
                <h2 className="text-xl font-semibold text-blue-600 mb-4">Cuentas Bancarias</h2>
                
                 <EditableWidget
                  title={"Cuentas Bancarias"}
                  displayWidget={
                    <ListaCuentasBancarias
                      cuentas={tutor.cuentas}
                    />
                  }
                  editWidget={
                     <CuentasBancariasForm
                      cuentas={tutor.cuentas} 
                      formData={formData} 
                      setFormData={setFormData} 
                    />
                  }
                  onSave={() =>{
                    updateTutorLocalAuxiliar('cuentas',formData.cuentas,'field');
                  }}
                  //isLoading={}
                  canEdit={true}
                />

              </div>

            </div>

            {/* Información Adicional */}
            <div className="lg:col-span-2">
              <div className="space-y-6">

                {/* Tipos de servicios */}
                <EditableWidget
                  title={"Tipos de servicios"}
                  displayWidget={
                    <ListaTiposServicios
                      tiposServicios={tutor.tipoServicios}
                    />
                  }
                  editWidget={
                    <SelectorTipoServicios
                      serviciosSeleccionados={tutor.tipoServicios}
                      formData={formData}
                      setFormData={setFormData}
                    />
                  }
                  onSave={() =>{
                    updateTutorLocalAuxiliar('tipoServicios',formData.tipoServicios,'field');
                  }}
                  canEdit={true}
                />

                {/* Materias manejadas */}
                <div className="bg-white rounded-lg shadow-lg p-6">
                  <div className="space-y-2">

                    <EditableWidget
                      title={"Materias manejadas"}
                      displayWidget={
                        <ListaMaterias
                          materias={tutor.materias}
                        />
                      }
                      editWidget={
                        <SelectorMaterias 
                        materias={materias} 
                        materiasSeleccionadas={materiaSeleccioandas}
                        setMateriasSeleccionadas={setMateriasSeleccionadas}
                      />
                      }
                      onSave={() =>{
                        updateTutorLocalAuxiliar('materias',materiaSeleccioandas,'field');
                      }}
                      //isLoading={}
                      canEdit={true}
                      />

                  </div>

                </div>

                {/* Experiencia laboral */}
                <div className="bg-white rounded-lg shadow-lg p-6">
                  
                  <EditableWidget
                    title={"Experiencia laboral"}
                    displayWidget={
                      <ListaExperienciaLaboral
                        experienciaLaboral={tutor.experienciaLaboral}
                      />    
                    }
                    editWidget={
                      <ExperienciaLaboralForm 
                          formData={formData} 
                          setFormData={setFormData} 
                      />     
                    }
                    onSave={() =>{
                      updateTutorLocalAuxiliar('experienciaLaboral',formData.experienciaLaboral,'field');
                    }}
                    //isLoading={}
                    canEdit={true}
                  />

                </div>

                {/* Sistema disciplinario */}
                <div className="bg-white rounded-lg shadow-lg p-6">
                  
                  <EditableWidget
                    title={"Sistema disciplinario (Aun no configurado)"}
                    displayWidget={
                      <></>   
                    }
                    editWidget={
                      <></>     
                    }
                    onSave={() =>{
                      //updateTutorLocalAuxiliar('experienciaLaboral',formData.experienciaLaboral,'field');
                    }}
                    //isLoading={}
                    canEdit={false}
                  />

                </div>

                {/* Anexos , hoja de vida, eliminar nada mas*/}
                <div className="bg-white rounded-lg shadow-lg p-6">
                  <h2 className="text-xl font-semibold text-blue-600 mb-4">Anexos</h2>
                  <div className="space-y-4">
                    <div>
                      <h3 className="font-medium mb-2">Hoja de vida (eliminar hoja de vida y poder cambiar)</h3>
                      {tutor?.hojadevida ? (
                        <button className="text-blue-600 hover:text-blue-800 underline">
                          Ver hoja de vida
                        </button>
                      ) : (
                        <p className="text-gray-500">No hay hoja de vida cargada</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Estado del examen */}
                <div className="bg-white rounded-lg shadow-lg p-6">
                  <div className="text-center py-8">
                    <div className="text-gray-500 mb-2">
                      {tutor?.examenAdmisionTutor?.finalizado ? 
                        'Examen completado' : 
                        'Examen no generado o no necesito'
                      }
                    </div>
                    {tutor?.examenAdmisionTutor?.aprobado && (
                      <div className="text-green-600 font-medium">✓ Aprobado</div>
                    )}
                  </div>
                </div>

                {/* Estadisticas del tutor*/}
                <div className="bg-white rounded-lg shadow-lg p-6">
                   <TutorStats stats={estadisticasTutores} loading={loadingEstadisticas} />
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }

  const vistaColaboradorAdmins = () => {
    // La variable 'editedTutor' viene del componente padre. 
    // Aquí la usamos solo para mostrar los datos.
    if (!tutor) {
        return <p className="text-gray-600">Cargando datos del colaborador...</p>;
    }

    // Componente auxiliar para mostrar un campo (Label + Value)
    const DisplayField = ({ label, value }) => (
        <div className="py-2 border-b border-gray-100">
            <p className="text-xs font-semibold text-gray-500 uppercase">{label}</p>
            <p className="text-md text-gray-800">{value || 'No especificado'}</p>
        </div>
    );

    // Componente auxiliar para mostrar el estado de un permiso
    const PermissionDisplay = ({ label, permissionKey }) => {
        const isEnabled = tutor.permisosUsuario?.[permissionKey] || false;

        return (
            <div className="flex items-center justify-between py-2">
                <span className="text-sm text-gray-700">{label}</span>
                <span
                    className={`px-3 py-1 text-xs font-bold leading-none rounded-full ${
                        isEnabled
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-200 text-gray-700'
                    }`}
                >
                    {isEnabled ? 'Activado' : 'Desactivado'}
                </span>
            </div>
        );
    };

    console.log("tutor permisos",tutor.permisosUsuario);

    return (
        <div className="max-w-6xl mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* --- Columna Izquierda: Información Personal --- */}
                <div className="lg:col-span-1 bg-white rounded-lg shadow-lg p-6 h-fit">
                    <div className="text-center mb-6">
                        <img
                            src={tutor.fotoPerfil || '/api/placeholder/150/150'}
                            alt="Foto de perfil"
                            className="w-32 h-32 rounded-full mx-auto border-4 border-blue-500 object-cover"
                        />
                    </div>

                    <h2 className="text-xl font-semibold text-blue-600 mb-4">Información personal</h2>
                    
                    <div className="space-y-2">
                        <EditableField
                          label="Nombre Whastapp"
                          value={tutor.nombrewhatsapp}
                          type="field"
                        />
                        <EditableField
                          label="Nombre Completo"
                          value={tutor.nombreCompleto}
                          type="field"
                        />
                        <EditableField
                          field="numero whatsapp"
                          label="Numero Whatsapp"
                          value={tutor.numeroWhatsapp}
                          type="number"
                          isAdmin={true}
                          onSave={updateTutorLocalAuxiliar}
                        />
                        <EditableField
                          label="Correo"
                          value={tutor.correogmail}
                        />

                        {/*iNFORMACION NO IMPORTANTE PARA UN COLABORADOR O ADMIN */}

                    </div>
                    
                </div>

                {/* --- Permisos y rol, solo el admin lo puede hacer --- */}
                <div className="lg:col-span-2 bg-white rounded-lg shadow-lg p-6 h-fit">
                    <h2 className="text-xl font-semibold text-blue-600 mb-4">Permisos y Rol Actual</h2>

                    {usuario.rol == "ADMIN" && (
                      <>
                      <div className="space-y-4">
                        {/* Mapeo de todos los permisos a su visualización */}
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS SOLICITUDES ---</h3>
                            <BooleanField
                              field="permisosUsuario.permiso_solicitudes"
                              label="Administrar solicitudes"
                              value={tutor.permisosUsuario.permiso_solicitudes}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                            <BooleanField
                              field="permisosUsuario.permisoTesis"
                              label="Administrar tesis"
                              value={tutor.permisosUsuario.permisoTesis}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                            <BooleanField
                              field="permisosUsuario.permisoProPlataforma"
                              label="Administrar proPlataforma"
                              value={tutor.permisosUsuario.permisoProPlataforma}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS TUTORES ---</h3>
                            <BooleanField
                              field="permisosUsuario.permiso_tutores"
                              label="Administrar tutores"
                              value={tutor.permisosUsuario.permiso_tutores}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS CALENDARIO ---</h3>
                            <BooleanField
                              field="permisosUsuario.permisoCalendario"
                              label="Permisos para calendario "
                              value={tutor.permisosUsuario.permisoCalendario}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS ESTADISTICAS ---</h3>
                            
                            <BooleanField
                              field="permisosUsuario.permiso_estadisticasPlataforma"
                              label="Permisos de estadisticas "
                              value={tutor.permisosUsuario.permiso_estadisticasPlataforma}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />

                            <BooleanField
                              field="permisosUsuario.permisoEstadisticasMarketing"
                              label="Permisos de marketing "
                              value={tutor.permisosUsuario.permisoEstadisticasMarketing}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />

                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS CONTABILIDAD ---</h3>
                            
                            <BooleanField
                              field="permisosUsuario.permiso_contabilidad_central"
                              label="Permisos para contabilidiad "
                              value={tutor.permisosUsuario.permiso_contabilidad_central}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />

                            <BooleanField
                              field="permisosUsuario.permisoCostos"
                              label="Permisos para costos "
                              value={tutor.permisosUsuario.permisoCostos}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />

                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS CONFIGURACIÓN ---</h3>
                            <BooleanField
                              field="permisosUsuario.permiso_configuracionGeneral"
                              label="Permisos para configuracion "
                              value={tutor.permisosUsuario.permiso_configuracionGeneral}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS WHATCHAT ---</h3>
                            <BooleanField
                              field="permisosUsuario.permisoWhatChat"
                              label="Permisos para WhaChat "
                              value={tutor.permisosUsuario.permisoWhatChat}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS CUENTAS DE COBRO ---</h3>
                            <BooleanField
                              field="permisosUsuario.permisoCuentaCobro"
                              label="Permisos para cuentas de cobro "
                              value={tutor.permisosUsuario.permisoCuentaCobro}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS NUEVOS TUTORES ---</h3>
                            <BooleanField
                              field="permisosUsuario.permisoNuevosTutores"
                              label="Permisos para nuevos tutores"
                              value={tutor.permisosUsuario.permisoNuevosTutores}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS CLIENTES ---</h3>
                            <BooleanField
                              field="permisosUsuario.permisoClientes"
                              label="Permisos para clientes "
                              value={tutor.permisosUsuario.permisoClientes}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-500 text-sm mb-2">--- PERMISOS SISTEMA DISCIPLINARIO ---</h3>
                            <BooleanField
                              field="permisosUsuario.permisoSaciones"
                              label="Permisos para sistema disciplinario"
                              value={tutor.permisosUsuario.permisoSaciones}
                              isAdmin={true}
                              displayAs='toggle'
                              onSave={updateTutorLocalAuxiliar}
                            />
                        </div>
                      </div>
                      </>
                    )}

                     {/* Rol Actual */}
                    <div className="mt-6 pt-6 border-t">
                        <DisplayField label="Rol Actual" value={tutor.rol} />
                    </div>
                    
                </div>

            </div>
        </div>
    );
  };

  const vistaProspectoTutor = () =>{

  }

  // Función para renderizar según el rol
  const renderizarVistaPorRol = () => {
    if (!tutor) {
      return (
        <div className="min-h-screen bg-gray-100 py-8 flex items-center justify-center">
          <p className="text-gray-600">No se encontró información del tutor</p>
        </div>
      );
    }

    // Renderizado condicional basado en el rol
    switch (tutor.rol) {
      case 'TUTOR':
        return vistaTutor();
      
      case 'COLABORADOR':
      case 'ADMIN':
        return vistaColaboradorAdmins();
      
      case 'PROSPECTO':
        return vistaProspectoTutor();
      
      default:
        return (
          <div className="min-h-screen bg-gray-100 py-8 flex items-center justify-center">
            <div className="text-center">
              <p className="text-gray-600 mb-4">Rol no reconocido: {tutor.rol}</p>
              <p className="text-sm text-gray-500">Contacta al administrador para resolver este problema</p>
            </div>
          </div>
        );
    }
  };

  return (
    <div>
      {renderizarVistaPorRol()}
    </div>
  );

}

export default DetallesTutor
